<div class="container-fluid p-0">
  <div class="row no-gutters">
    <div class="col-lg-2">
      <app-navbar></app-navbar>
    </div>
    <div class="col-lg-10 contenido">
      <div class="d-flex align-items-center justify-content-between">
        <h4 class="mb-0">Paquetes (V2)</h4>
        <span *ngIf="loading" class="badge badge-info">Cargando...</span>
      </div>
      <hr />

      <datalist id="tipos-productos-paquete-list">
        <option *ngFor="let tipo of tiposProductosDisponibles" [value]="tipo"></option>
      </datalist>
      <datalist id="productos-paquete-list">
        <option *ngFor="let p of productosDisponiblesFiltrados" [value]="getProductoOptionLabel(p)"></option>
      </datalist>

      <div class="card mb-3">
        <div class="card-body">
          <h6 class="card-title">Agregar paquete</h6>
          <div class="form-row align-items-end">
            <div class="col-md-2">
              <label class="font-weight-bold">Nombre</label>
              <input class="form-control" [(ngModel)]="formulario.nombre" placeholder="Nombre del paquete" />
            </div>
            <div class="col-md-3">
              <label class="font-weight-bold">Descripcion</label>
              <input class="form-control" [(ngModel)]="formulario.descripcion" placeholder="Detalle visible al alumno" />
            </div>
            <div class="col-md-2">
              <label class="font-weight-bold">Precio visible</label>
              <input class="form-control" [(ngModel)]="formulario.precio" placeholder="Opcional" />
            </div>
            <div class="col-md-2">
              <label class="font-weight-bold">Imagen</label>
              <input type="file" class="form-control-file" (change)="onFileChangeNuevo($event)" />
            </div>
            <div class="col-md-3">
              <label class="font-weight-bold">Familia</label>
              <select class="form-control" [(ngModel)]="formulario.familia">
                <option value="">Sin familia</option>
                <option *ngFor="let familia of familias" [value]="familia.id">{{ familia.nombre }}</option>
              </select>
            </div>
          </div>
          <div class="form-row align-items-end mt-3">
            <div class="col-md-2">
              <label class="font-weight-bold">Activo</label>
              <select class="form-control" [(ngModel)]="formulario.activo">
                <option [value]="1">Si</option>
                <option [value]="0">No</option>
              </select>
            </div>
            <div class="col-md-3 mt-3 mt-md-0 d-flex align-items-end">
              <button class="btn btn-success btn-block" (click)="agregarPaquete()">Guardar</button>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-body">
          <div class="d-flex align-items-center justify-content-between flex-wrap">
            <h6 class="card-title mb-0">Listado</h6>
            <div class="input-group search-box">
              <div class="input-group-prepend">
                <span class="input-group-text">Buscar</span>
              </div>
              <input class="form-control" [(ngModel)]="filtro" placeholder="Buscar paquete o familia" />
            </div>
          </div>
          <div class="table-responsive">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>Id</th>
                  <th>Nombre</th>
                  <th>Imagen</th>
                  <th>Familia</th>
                  <th>Precio</th>
                  <th>Activo</th>
                  <th class="text-right">Acciones</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let paquete of paquetesFiltrados">
                  <td>{{ paquete.id }}</td>
                  <td>{{ paquete.nombre }}</td>
                  <td>
                    <img *ngIf="paquete.imagen" [src]="paquete.imagen" alt="imagen paquete" class="thumb">
                    <span *ngIf="!paquete.imagen">-</span>
                  </td>
                  <td>{{ getFamiliaNombre(paquete) || '-' }}</td>
                  <td>{{ paquete.precio || '-' }}</td>
                  <td>{{ paquete.activo === 0 ? 'No' : 'Si' }}</td>
                  <td class="text-right actions-cell">
                    <button class="btn btn-sm btn-outline-secondary" (click)="abrirProductos(productosPaqueteModal, paquete)">Productos</button>
                    <button class="btn btn-sm btn-outline-primary" (click)="abrirEditar(editPaqueteModal, paquete)">Editar</button>
                    <button class="btn btn-sm btn-outline-danger" (click)="eliminarPaquete(paquete.id)">Eliminar</button>
                  </td>
                </tr>
                <tr *ngIf="!paquetesFiltrados.length">
                  <td colspan="7" class="text-center text-muted">Sin paquetes v2.</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #editPaqueteModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="modal-editar-paquete">Editar paquete</h5>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="form-group">
      <label class="font-weight-bold">Nombre</label>
      <input class="form-control" [(ngModel)]="formularioEdit.nombre" />
    </div>
    <div class="form-group">
      <label class="font-weight-bold">Descripcion</label>
      <textarea class="form-control" rows="3" [(ngModel)]="formularioEdit.descripcion"></textarea>
    </div>
    <div class="form-group">
      <label class="font-weight-bold">Precio visible</label>
      <input class="form-control" [(ngModel)]="formularioEdit.precio" />
    </div>
    <div class="form-group">
      <label class="font-weight-bold">Imagen</label>
      <input type="file" class="form-control-file" (change)="onFileChangeEditar($event)" />
    </div>
    <div class="form-group">
      <label class="font-weight-bold">Familia</label>
      <select class="form-control" [(ngModel)]="formularioEdit.familia">
        <option value="">Sin familia</option>
        <option *ngFor="let familia of familias" [value]="familia.id">{{ familia.nombre }}</option>
      </select>
    </div>
    <div class="form-group">
      <label class="font-weight-bold">Activo</label>
      <select class="form-control" [(ngModel)]="formularioEdit.activo">
        <option [value]="1">Si</option>
        <option [value]="0">No</option>
      </select>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cancelar</button>
    <button type="button" class="btn btn-primary" (click)="actualizarPaquete()">Guardar</button>
  </div>
</ng-template>

<ng-template #productosPaqueteModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="modal-productos-paquete">Productos de {{ paqueteSeleccionado?.nombre }}</h5>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="card mb-3">
      <div class="card-body">
        <h6 class="card-title">Agregar producto v2 al paquete</h6>
        <div class="form-row align-items-end">
          <div class="col-md-3">
            <label class="font-weight-bold">Buscar por tipo</label>
            <input class="form-control" list="tipos-productos-paquete-list" [(ngModel)]="filtroTipoProductoDisponible" placeholder="moldura, color, cuadro" />
          </div>
          <div class="col-md-7">
            <label class="font-weight-bold">Buscar y elegir producto</label>
            <input
              class="form-control"
              list="productos-paquete-list"
              [ngModel]="productoInput"
              (ngModelChange)="onProductoInputChange($event)"
              placeholder="Escribe id, nombre o tipo de producto" />
          </div>
          <div class="col-md-2 mt-3 mt-md-0">
            <button class="btn btn-success btn-block" (click)="agregarProductoPaquete()">Agregar</button>
          </div>
          <div class="col-12 mt-2 text-muted">
            {{ productosDisponiblesFiltrados.length }} producto(s) disponibles con filtros actuales
          </div>
        </div>
      </div>
    </div>

    <div class="d-flex align-items-center justify-content-between flex-wrap">
      <h6 class="mb-0">Productos asignados</h6>
      <input class="form-control modal-search" [(ngModel)]="filtroProductoPaquete" placeholder="Buscar asignado por nombre o tipo" />
    </div>

    <div class="table-responsive mt-3">
      <table class="table table-striped">
        <thead>
          <tr>
            <th>Producto</th>
            <th>Tipo</th>
            <th>Descripcion</th>
            <th>Imagen</th>
            <th>Activo</th>
            <th class="text-right">Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let pp of productosPaqueteFiltrados">
            <td>{{ pp.producto_detalle?.nombre || pp.producto_nombre || getProductoNombre(pp.producto) }}</td>
            <td>{{ pp.producto_detalle?.tipo || pp.producto_tipo || getProductoTipo(pp.producto) || '-' }}</td>
            <td>{{ pp.producto_detalle?.descripcion || getProductoDescripcion(pp.producto) || '-' }}</td>
            <td>
              <img *ngIf="pp.producto_detalle?.imagen || getProductoImagen(pp.producto)" [src]="pp.producto_detalle?.imagen || getProductoImagen(pp.producto)" alt="img producto" class="thumb">
              <span *ngIf="!(pp.producto_detalle?.imagen || getProductoImagen(pp.producto))">-</span>
            </td>
            <td>{{ pp.activo === 0 ? 'No' : 'Si' }}</td>
            <td class="text-right actions-cell">
              <button class="btn btn-sm btn-outline-warning" (click)="toggleProductoPaquete(pp)">
                {{ pp.activo === 0 ? 'Activar' : 'Desactivar' }}
              </button>
              <button class="btn btn-sm btn-outline-danger" (click)="eliminarProductoPaquete(pp)">Eliminar</button>
            </td>
          </tr>
          <tr *ngIf="!productosPaqueteFiltrados.length">
            <td colspan="6" class="text-center text-muted">Sin productos asignados.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cerrar</button>
  </div>
</ng-template>
